import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@claritio/frontend/lib/utils'

// Never shown while data is still loading; show a skeleton then.
export function EmptyState({ icon: Icon, title, description, action, className }: {
  icon?: LucideIcon
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-center gap-2 rounded-2xl border border-dashed border-input px-6 py-12 text-center', className)}>
      {Icon && (
        <span className="mb-1 grid size-10 place-items-center rounded-full bg-muted text-muted-foreground">
          <Icon aria-hidden className="size-5" />
        </span>
      )}
      <h3 className="font-heading text-title">{title}</h3>
      {description && <p className="max-w-[46ch] text-muted-foreground">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
